'use client'

import { Check } from 'lucide-react'

import { Button } from '@/components/ui/button'
import type { SettingsSummaryItem } from '@/lib/needs/settings-summary'
import type { ScoredCourse } from '@/lib/needs/recommend-courses'

import { RecommendedCourses } from './RecommendedCourses'

interface NeedsPreviewStepProps {
  summary: SettingsSummaryItem[]
  recommendations: ScoredCourse[]
  onBack: () => void
  onSave: () => void
}

export function NeedsPreviewStep({
  summary,
  recommendations,
  onBack,
  onSave,
}: NeedsPreviewStepProps) {
  return (
    <div className="flex flex-col gap-8">
      <div className="flex flex-col gap-3">
        <h2 className="text-2xl font-semibold">Pogledaj kako izgleda</h2>
        <p className="text-muted-foreground">
          Već smo prilagodili stranicu tvojim potrebama. Promene vidiš odmah. Ako ti odgovara,
          sačuvaj ih — uvek ih kasnije možeš promeniti u traci za pristupačnost.
        </p>
      </div>

      {summary.length > 0 ? (
        <section aria-labelledby="changes-heading" className="flex flex-col gap-3">
          <h3 id="changes-heading" className="text-lg font-semibold">
            Ovo smo uključili za tebe
          </h3>
          <ul className="flex flex-col gap-2">
            {summary.map((item) => (
              <li key={item.key} className="flex items-center gap-2">
                <Check aria-hidden="true" className="text-success h-5 w-5 shrink-0" />
                <span>{item.label}</span>
              </li>
            ))}
          </ul>
        </section>
      ) : (
        <p className="text-muted-foreground">
          Nismo menjali podešavanja. To je sasvim u redu — možeš nastaviti ovako ili kasnije
          podesiti sve u traci za pristupačnost.
        </p>
      )}

      <section
        aria-labelledby="sample-heading"
        className="bg-surface flex flex-col gap-2 rounded-lg border p-5"
      >
        <h3 id="sample-heading" className="text-lg font-semibold">
          Primer teksta
        </h3>
        <p>
          Ovo je primer kako će tekst izgledati dok učiš. Rečenice su kratke. Reči su jasne. Cilj je
          da ti čitanje bude lako i prijatno.
        </p>
      </section>

      {recommendations.length > 0 && <RecommendedCourses recommendations={recommendations} />}

      <div className="flex flex-col-reverse gap-3 sm:flex-row sm:justify-between">
        <Button type="button" variant="outline" onClick={onBack}>
          Nazad
        </Button>
        <Button type="button" onClick={onSave}>
          Sačuvaj podešavanja
        </Button>
      </div>
    </div>
  )
}
